import Header from "@/components/feature/Header";
import Footer from "@/components/feature/Footer";
import BackToTop from "@/components/feature/BackToTop";
import Hero from "@/pages/home/components/Hero";
import FeaturedSection from "@/pages/home/components/FeaturedSection";
import LatestFeed from "@/pages/home/components/LatestFeed";
import HotRankingSection from "@/pages/home/components/HotRankingSection";
import TopicSection from "@/pages/home/components/TopicSection";
import ColumnsSection from "@/pages/home/components/ColumnsSection";
import FaqSection from "@/pages/home/components/FaqSection";
import AboutSection from "@/pages/home/components/AboutSection";
import SubscribeSection from "@/pages/home/components/SubscribeSection";
import { navAnchors } from "@/mocks/news";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <Header />

      <main>
        <Hero />

        <nav aria-label="面包屑导航" className="w-full border-b border-background-200 bg-background-50">
          <ol className="mx-auto flex w-full max-w-[1280px] flex-wrap items-center gap-2 px-4 py-3 text-xs text-foreground-500 md:px-8">
            <li>
              <a href="#top" className="text-foreground-700 transition-colors hover:text-primary-600">
                首页
              </a>
            </li>
            <li aria-hidden>/</li>
            <li className="text-foreground-900">今日首发</li>
            <li aria-hidden>/</li>
            <li className="text-foreground-900">最新爆料</li>
          </ol>
        </nav>

        <FeaturedSection />
        <LatestFeed />
        <HotRankingSection />
        <TopicSection />
        <ColumnsSection />
        <FaqSection />
        <AboutSection />
        <SubscribeSection />
      </main>

      <nav aria-label="页面内容目录" className="w-full border-t border-background-200 bg-background-100">
        <div className="mx-auto flex w-full max-w-[1280px] flex-wrap items-center gap-x-5 gap-y-2 px-4 py-6 md:px-8">
          <span className="text-xs text-foreground-500">内容目录</span>
          {navAnchors.map((item) => (
            <a
              key={item.href}
              href={item.href}
              className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {item.label}
            </a>
          ))}
        </div>
      </nav>

      <Footer />
      <BackToTop />
    </div>
  );
}